<twc-popup type="primary" caption="{{'PERMISSION_DIALOG.EDIT_PERMISSIONS' | translate}}" [width]="600" #editPermissions>
    <twc-popup-content>
        <!-- Name and owner -->
        <div class="twc-form">
            <div class="twc-form-control">
                <label for="firstName" class="twc-form-label"> {{'PERMISSION_DIALOG.OBJECT' | translate}} </label>
                <div class="twc-form-element">
                    <input class="twc-input" [ngModel]="permissionsEditorService.permissionsObjectName"
                        [disabled]="true">
                </div>
            </div>
            <div class="twc-form-control">
                <label for="firstName" class="twc-form-label"> {{'PERMISSION_DIALOG.OWNER' | translate}} </label>
                <div class="twc-form-element">
                    <input class="twc-input" [ngModel]="permissionsEditorService.objectOwner" [disabled]="true">
                </div>
            </div>
        </div>

        <!-- Authorized groups -->
        <div class="twc-row twc-mt-3 permissions-container-header">
            <div class="twc-col-6 twc-h5 twc-mb-0">
                {{ 'PERMISSION_DIALOG.AUTHORIZED_GROUPS' | translate}}
            </div>
            <div class="twc-col-6 buttons-container">
                <button class="twc-button twc-button-link twc-button-icon"
                    (click)="permissionsEditorService.openViewGroupMembersPopup()"
                    [disabled]="permissionsEditorService.isDisabledViewMembersGroupButton()">
                    <twc-icon shape="group" [size]="40"
                        twcTooltip="{{'PERMISSION_DIALOG.VIEW_MEMBERS' | translate}}"></twc-icon>
                </button>
                <button class="twc-button twc-button-link twc-button-icon"
                    (click)="permissionsEditorService.openAddGroupPopup()"
                    [disabled]="permissionsEditorService.isDisabledAddGroupButton() ">
                    <twc-icon shape="group-add" twcTooltip="{{'PERMISSION_DIALOG.ADD_GROUP' | translate}}"></twc-icon>
                </button>
                <button class="twc-button twc-button-link twc-button-icon"
                    (click)="permissionsEditorService.removeGroup()"
                    [disabled]="permissionsEditorService.isDisabledRemoveGroupButton()">
                    <twc-icon shape="group-remove"
                        twcTooltip="{{'PERMISSION_DIALOG.REMOVE_GROUP' | translate}}"></twc-icon>
                </button>
            </div>
        </div>
        <div class="twc-row min-height-list "
            *ngIf="!permissionsEditorService.isLoadingGroupList; else loadingGroupList">
            <div class="twc-col-12">
                <cw-permissions-list [list]="permissionsEditorService.groupPermissionList"
                    (selectItem)="permissionsEditorService.onSelectItemGroup($event)"
                    (actionClick)="permissionsEditorService.onActionGroupClick($event)">
                </cw-permissions-list>
            </div>
        </div>
        <ng-template #loadingGroupList>
            <div class="twc-row min-height-list">
                <div class="twc-col-12">
                    <div class="twc-d-flex justify-content-center width-100">
                        <twc-loader></twc-loader>
                    </div>
                </div>
            </div>
        </ng-template>

        <!-- User Exceptions -->
        <div class="twc-row twc-mt-3 permissions-container-header">
            <div class="twc-col-6 twc-h5 twc-mb-0">
                {{ 'PERMISSION_DIALOG.USER_OVERRIDES' | translate}}
            </div>
            <div class="twc-col-6 buttons-container">
                <button class="twc-button twc-button-link twc-button-icon"
                    (click)="permissionsEditorService.openViewUserInheritsPopup()"
                    [disabled]="permissionsEditorService.isDisabledViewUserInherits()">
                    <twc-icon shape="user" [size]="40"
                        twcTooltip="{{'PERMISSION_DIALOG.VIEW_INHERITS' | translate}}"></twc-icon>
                </button>
                <button class="twc-button twc-button-link twc-button-icon"
                    (click)="permissionsEditorService.openAddUserPopup()"
                    [disabled]="permissionsEditorService.isDisabledAddUser()">
                    <twc-icon shape="user-add-right"
                        twcTooltip="{{'PERMISSION_DIALOG.ADD_USER' | translate}}"></twc-icon>
                </button>
                <button class="twc-button twc-button-link twc-button-icon"
                    (click)="permissionsEditorService.removeUser()"
                    [disabled]="permissionsEditorService.isDisabledRemoveUser()">
                    <twc-icon shape="user-remove"
                        twcTooltip="{{'PERMISSION_DIALOG.REMOVE_USER' | translate}}"></twc-icon>
                </button>
            </div>
        </div>
        <div class="twc-row min-height-list" *ngIf="!permissionsEditorService.isLoadingUserList; else loadingUserList">
            <div class="twc-col-12">
                <cw-permissions-list [list]="permissionsEditorService.userPermissionList"
                    (selectItem)="permissionsEditorService.onSelectItemUser($event)"
                    (actionClick)="permissionsEditorService.onActionUserClick($event)">
                </cw-permissions-list>
            </div>
        </div>

        <ng-template #loadingUserList>
            <div class="twc-row min-height-list">
                <div class="twc-col-12">
                    <div class="twc-d-flex justify-content-center width-100">
                        <twc-loader></twc-loader>
                    </div>
                </div>
            </div>
        </ng-template>

    </twc-popup-content>
</twc-popup>